import { useMutation } from 'react-query';
import { deleteCode } from 'src/services/api/codes';

function useDeleteCode() {
  return useMutation((code) => deleteCode(code));
}

export default useDeleteCode;
